import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";

export const MatomoRouteTracker = () => {
  const location = useLocation();
  const { trackPageView, trackEvent } = useMatomo();

  useEffect(() => {
    trackPageView({ href: window.location.href });
    // trackEvent({ category: 'page', name: location.pathname, action: 'visited',  })
    window._mtm && window._mtm.push({ event: 'mtm.PageView', url: window.location.href, title: document.title });
  }, [location]);

  return null;
};